var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonChartTemplate',{attrs:{"datasets":_vm.datasets,"loading":_vm.loading,"tooltip-formatter":_vm.tooltipFormatter,"legend-options":{ selected: _vm.selected },"x-labels":_vm.xLabels},on:{"legendselectchanged":_vm.controlSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }